module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "m-form",
    attrs: {
      "name": "claimForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [(_vm.showNames) ? _c('control', {
    attrs: {
      "for": "claimantName",
      "label": "Claimant Name"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.claimantName),
      expression: "claimantName"
    }, {
      name: "field-control",
      rawName: "v-field-control:claimantName.required",
      value: ({
        type: 'text',
        rules: 'name'
      }),
      expression: "{type:'text', rules:'name'}",
      arg: "claimantName",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "claimantName",
      "id": "claimantName",
      "maxlength": "100",
      "type": "text"
    },
    domProps: {
      "value": (_vm.claimantName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.claimantName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimantName')
    }
  }, [_vm._v("The claimant name is required and must be a valid name")])], 1) : _vm._e(), _vm._v(" "), _c('typeahead', {
    attrs: {
      "required": true,
      "label": 'Claimant Solicitors',
      "error-message": 'The claimant solicitor is required and must be a valid name',
      "value": _vm.claimantSolicitor,
      "type": 'claimant_solicitors'
    },
    on: {
      "update": _vm.updateClaimantSolicitors
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "for": "claimaint_reference",
      "label": "Claimant Reference"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.claimantReference),
      expression: "claimantReference"
    }, {
      name: "field-control",
      rawName: "v-field-control:claimantReference.required",
      value: ({
        type: 'text'
      }),
      expression: "{type:'text'}",
      arg: "claimantReference",
      modifiers: {
        "required": true
      }
    }],
    staticClass: "input",
    attrs: {
      "autocomplete": "off",
      "required": "",
      "maxlength": "100",
      "name": "claimaint_reference",
      "type": "text"
    },
    domProps: {
      "value": (_vm.claimantReference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.claimantReference = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimantReference')
    }
  }, [_vm._v("The claimant reference is required")])], 1), _vm._v(" "), _c('typeahead', {
    attrs: {
      "required": true,
      "label": 'Defendant Name',
      "error-message": 'The defendant name is required and must be a valid name',
      "value": _vm.defendantName,
      "type": 'defendant'
    },
    on: {
      "update": _vm.updateDefendant
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "name": "disease_or_accident",
      "label": "Disease or Accident?"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.diseaseOrAccident),
      expression: "diseaseOrAccident"
    }],
    attrs: {
      "name": "disease_or_accident",
      "id": "disease_or_accident",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.diseaseOrAccident = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "disease"
    }
  }, [_vm._v("Disease")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "accident"
    }
  }, [_vm._v("Accident")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('disease_or_accident')
    }
  }, [_vm._v("The disease type is required")])], 1), _vm._v(" "), (_vm.diseaseOrAccident === 'disease') ? _c('div', [_c('control', {
    attrs: {
      "name": "disease_type",
      "label": "Disease"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.diseaseType),
      expression: "diseaseType"
    }],
    attrs: {
      "name": "disease_type",
      "id": "disease_type",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.diseaseType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asbestos Related Lung Cancer"
    }
  }, [_vm._v("Asbestos Related Lung Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Bladder Cancer"
    }
  }, [_vm._v("Bladder Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Kidney Cancer"
    }
  }, [_vm._v("Kidney Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Laryngeal Cancer"
    }
  }, [_vm._v("Laryngeal Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Leukemia"
    }
  }, [_vm._v("Leukemia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Liver Cancer"
    }
  }, [_vm._v("Liver Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mesothelioma"
    }
  }, [_vm._v("Mesothelioma")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nasal Cancer"
    }
  }, [_vm._v("Nasal Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Skin Cancer"
    }
  }, [_vm._v("Skin Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("- - -")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other Cancer"
    }
  }, [_vm._v("Other Cancer — Specify Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("- - -")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other — Specify Type")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('disease_type')
    }
  }, [_vm._v("The disease type is required")])], 1), _vm._v(" "), (_vm.diseaseType && _vm.diseaseType.substr(0, 5) === 'Other') ? _c('control', {
    attrs: {
      "name": "disease_type_other",
      "label": "Disease Type Other"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.otherDiseaseType),
      expression: "otherDiseaseType"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "disease_type_other",
      "id": "disease_type_other",
      "required": ""
    },
    domProps: {
      "value": (_vm.otherDiseaseType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otherDiseaseType = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('disease_type_other') || _vm.otherDiseaseType === null
    }
  }, [_vm._v("The disease type is required")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.diseaseOrAccident === 'accident') ? _c('div', [_c('control', {
    attrs: {
      "name": "accident_type",
      "label": "Accident"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.accidentType),
      expression: "accidentType"
    }],
    attrs: {
      "name": "accident_type",
      "id": "accident_type",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.accidentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accident - EL"
    }
  }, [_vm._v("Accident - EL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accident - PL"
    }
  }, [_vm._v("Accident - PL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Motor"
    }
  }, [_vm._v("Motor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other — Specify Type")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('accident_type')
    }
  }, [_vm._v("The accident type is required")])], 1), _vm._v(" "), (_vm.accidentType && _vm.accidentType.substr(0, 5) === 'Other') ? _c('control', {
    attrs: {
      "name": "accident_type_other",
      "label": "Accident Type Other"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.otherAccidentType),
      expression: "otherAccidentType"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "accident_type_other",
      "id": "accident_type_other",
      "required": ""
    },
    domProps: {
      "value": (_vm.otherAccidentType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otherAccidentType = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('accident_type_other') || _vm.otherAccidentType === null
    }
  }, [_vm._v("The accident type is required")])], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "for": "your_reference",
      "label": "Your Reference"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yourReference),
      expression: "yourReference"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "your_reference",
      "maxlength": "30",
      "type": "text"
    },
    domProps: {
      "value": (_vm.yourReference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.yourReference = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('your_reference')
    }
  }, [_vm._v("Your reference is required")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "pre_lit_or_lit",
      "label": "Procedural Status"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preLitOrLit),
      expression: "preLitOrLit"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "pre_lit_or_lit",
      "id": "pre_lit_or_lit",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.preLitOrLit = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "pre-lit"
    }
  }, [_vm._v("Pre-Litigation")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "litigated"
    }
  }, [_vm._v("Litigated")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('pre_lit_or_lit')
    }
  }, [_vm._v("Procedural status is required")])], 1), _vm._v(" "), (_vm.preLitOrLit == 'litigated') ? _c('control', {
    attrs: {
      "for": "date_of_service_proceedings",
      "label": "Date of Service of Proceedings"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_of_service_proceedings.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_of_service_proceedings",
      modifiers: {
        "required": true
      }
    }],
    model: {
      value: (_vm.dateOfServiceProceedings),
      callback: function($$v) {
        _vm.dateOfServiceProceedings = $$v
      },
      expression: "dateOfServiceProceedings"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_service_proceedings') || _vm.showServiceOfProceedingsValidationMessage_required
    }
  }, [_vm._v("Date of service of proceedings is required in the format DD/MM/YYYY")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.showServiceOfProceedingsValidationMessage_before
    }
  }, [_vm._v("Date of service of proceedings must be before the date of assumed settlement")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.showServiceOfProceedingsValidationMessage_9years
    }
  }, [_vm._v("\n            Date of service of proceeding cannot be more than 9 years before the date of assumed\n            settlement\n          ")])], 1) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_of_assumed_settlement",
      "label": "Date of Assumed Settlement"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_of_assumed_settlement.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_of_assumed_settlement",
      modifiers: {
        "required": true
      }
    }],
    model: {
      value: (_vm.dateOfAssumedSettlement),
      callback: function($$v) {
        _vm.dateOfAssumedSettlement = $$v
      },
      expression: "dateOfAssumedSettlement"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_assumed_settlement')
    }
  }, [_vm._v("Date of assumed settlement is required in the format DD/MM/YYYY")]), _vm._v(" "), _c('control-warning', {
    attrs: {
      "show": _vm.dateOfAssumedSettlementInPast
    }
  }, [_c('warning-box', {
    attrs: {
      "modal-name": "warning"
    }
  }, [_c('svg', {
    staticClass: "m-icon m-icon--dark m-icon--small open",
    attrs: {
      "slot": "icon",
      "viewBox": "0 0 120 120"
    },
    slot: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#warning"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "c-warning-box__orange"
  }, [_vm._v("Date of assumed settlement is in the past")])])], 1)], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "discount_rate",
      "label": "Discount Rate"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discountRate),
      expression: "discountRate"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "discount_rate",
      "id": "discount_rate",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discountRate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": -2.0
    }
  }, [_vm._v("-2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.5
    }
  }, [_vm._v("-1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.0
    }
  }, [_vm._v("-1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.75
    }
  }, [_vm._v("-0.75%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.5
    }
  }, [_vm._v("-0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.25
    }
  }, [_vm._v("-0.25%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.0
    }
  }, [_vm._v("0.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.5
    }
  }, [_vm._v("0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.0
    }
  }, [_vm._v("1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.5
    }
  }, [_vm._v("1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.0
    }
  }, [_vm._v("2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.5
    }
  }, [_vm._v("2.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3.0
    }
  }, [_vm._v("3.00%")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('discount_rate')
    }
  }, [_vm._v("Discount rate is required")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs flex-grid__item--full"
  }, [_c('control', {
    attrs: {
      "for": "claim_narrative",
      "label": "Claim Narrative",
      "tip-text": "Provide a brief background to the claim and issues in dispute. This narrative will populate your counter-schedule of loss.",
      "tip-icon": "info",
      "tip-side": "left",
      "tip-width": "250",
      "tip-name": "claim_narrative"
    }
  }, [_c('textarea', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:claim_narrative.required",
      value: ({
        type: 'text'
      }),
      expression: "{type:'text'}",
      arg: "claim_narrative",
      modifiers: {
        "required": true
      }
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.narrative),
      expression: "narrative"
    }],
    staticClass: "u-full-width",
    attrs: {
      "required": "",
      "rows": "4",
      "name": "claim_narrative"
    },
    domProps: {
      "value": (_vm.narrative)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.narrative = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claim_narrative')
    }
  }, [_vm._v("The claim narrative is required")])], 1)], 1)]), _vm._v(" "), _c('step-button', {
    attrs: {
      "prev-valid": false,
      "next-valid": _vm.isValid
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5594c4e6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/fatal-accident-claims/dependency/steps/ClaimDetails.vue
// module id = 1696
// module chunks = 0